import { getIntervalByGranularity } from '@utils/granularity';
import { granularity as getGranularity, jsonTransform } from '@utils';
import { getMetricMetaByKey } from '@utils/metrics';
import { lineChartReqBody as diagReqBody } from '../utils/metricCardsReqBodyTemplate';
import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

const lineChartOptions = (metricObj) => {
  const metricName = Object.keys(metricObj)[0];

  return {
    'data*data.timestamp': [['data.timestamp', `data.results.${metricName}`]],
    _metric: metricName,
    _title: metricObj[metricName].displayName,
    _shortMetric: metricObj[metricName].short,
    _subscript: metricObj[metricName].subscript,
    _unit: metricObj[metricName].unit,
    _aggregate: `totals.${metricName}`,
    _deviation: 'totals.deviation',
  };
};

export const getDiagChartQuery = (filter, metric, start, end) => {
  const newMetric = getPercentageMetricByKey({ metricKey: metric, defaultValue: metric });
  const body = JSON.parse(JSON.stringify(diagReqBody));
  const granularity = getGranularity({ from: start, to: end, minuteGranularity: true });
  const { from, to } = getIntervalByGranularity({ from: start, to: end }, granularity);
  body.queries[0].filter = filter;
  body.queries[0].metrics = [newMetric];
  body.queries[0].interval = `${from}/${to}`;
  body.queries[0].granularity = getGranularity({ from: start, to: end, minuteGranularity: true });
  return body;
};

export const transferResponse = (metric, response) => {
  const newMetric = getPercentageMetricByKey({ metricKey: metric, defaultValue: metric });
  const targetSchema = lineChartOptions({
    [newMetric]: getMetricMetaByKey({ metricKey: newMetric }),
  });
  return jsonTransform(response.data, targetSchema);
};

export const compareGranularity = ({ from, to, sliderStart, sliderEnd }) =>
  getGranularity({ from, to, minuteGranularity: true }) ===
  getGranularity({ from: sliderStart, to: sliderEnd, minuteGranularity: true });
